import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-navy/10 bg-white py-10 sm:py-14" data-id="element-193" data-mp="1tai2pb8gatrc">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-194" data-mp="1t8duih3ir8l9">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-navy/10' : ''}`} data-id="element-195" data-mp="1jckfmr2bv30b" data-mpi={index}>
            <dt className="sr-only" data-id="element-196" data-mp="1edh9t4eiwsra">{stat.label}</dt>
            <dd data-id="element-197" data-mp="1efbuqipsokvd">
              <span className="block font-display text-4xl font-black text-navy sm:text-5xl" data-id="element-198" data-mp="19miua71czyp3">
                {stat.value}
              </span>
              <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-navy/45 sm:text-[11px]" data-id="element-199" data-mp="15lp4f84cw9tk">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}